import Cookies from 'js-cookie';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import CenterModal from '../CenterModal';

// import { AdminContext } from '../../../context/AdminContext';
import Checkbox from '../CheckBox';
import styles from './styles.module.scss';

const FooterMoreBox = ({
  onClickLang = () => console.log('theme'),
  extraClassName = 'nothing',
}) => {
  const {
    themeColor,
    themeMode,
    direction,
    setDirection,
    content,
    setContent,
    lang,
    setLang,
    openShare,
    setOpenShare,
  } = useContext(AdminContext);
  const [activeId, setActiveId] = useState();
  //   const [openShare, setOpenShare] = useState(false);

  const chooseFunction = (id) => {
    if (id == 1) {
      setOpenShare(true);
    }
  };

  return (
    <div className={`${styles.ProfileMenuMiddle} noBorder `}>
      <div
        className={`flex flex-col justify-start items-start ${extraClassName}`}
      >
        {content?.footerMoreBox?.map((item, index) => (
          <div
            className={`flex flex-row justify-start items-center my-[8px] mx-[2px] cursor-pointer`}
            onClick={() => {
              chooseFunction(item?.id);
            }}
          >
            {item?.icon}
            {/* <div className={`mx-8px ${themeMode != 'white' && 'textWhite'}`}>
              {item?.name}
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterMoreBox;
